import { render, staticRenderFns } from "./deliverydetail.vue?vue&type=template&id=e3bceba0&scoped=true"
import script from "./deliverydetail.vue?vue&type=script&lang=js"
export * from "./deliverydetail.vue?vue&type=script&lang=js"
import style0 from "./deliverydetail.vue?vue&type=style&index=0&id=e3bceba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bceba0",
  null
  
)

export default component.exports